// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addressInfoDisplayStyles } from "@tps/Overrides/Components/AddressInfoDisplay";
import { getSharedAddressInfoDisplayStyles } from "@tps/XDL/Utilities";
import { css } from "styled-components";

addressInfoDisplayStyles.customerNameText = { ...getSharedAddressInfoDisplayStyles().customerNameText };
addressInfoDisplayStyles.attentionText = { ...getSharedAddressInfoDisplayStyles().attentionText };
addressInfoDisplayStyles.companyNameText = { ...getSharedAddressInfoDisplayStyles().companyNameText };
addressInfoDisplayStyles.address1Text = { ...getSharedAddressInfoDisplayStyles().address1Text };
addressInfoDisplayStyles.address2Text = { ...getSharedAddressInfoDisplayStyles().address2Text };
addressInfoDisplayStyles.address3Text = { ...getSharedAddressInfoDisplayStyles().address3Text };
addressInfoDisplayStyles.address4Text = { ...getSharedAddressInfoDisplayStyles().address4Text };
addressInfoDisplayStyles.cityStatePostalCodeText = { ...getSharedAddressInfoDisplayStyles().cityStatePostalCodeText };
addressInfoDisplayStyles.countryText = { ...getSharedAddressInfoDisplayStyles().countryText };
addressInfoDisplayStyles.phoneText = { ...getSharedAddressInfoDisplayStyles().phoneText };
addressInfoDisplayStyles.emailText = { ...getSharedAddressInfoDisplayStyles().emailText };
addressInfoDisplayStyles.faxText = { ...getSharedAddressInfoDisplayStyles().faxText };

addressInfoDisplayStyles.multipleWarehousesText = {
    as: "p",
    css: css`
        font-size: 14px;
        line-height: 22px;
    `,
};
